import { truncateOfficeAndFloor } from "@gettactic/helpers";

interface OfficeFloorInfoProps {
  officeName?: string;
  floorName?: string;
  className?: string;
  officeClassName?: string;
  floorClassName?: string;
}

export function OfficeFloorInfo({
  officeName,
  floorName,
  className = "mt-0.5 flex items-center gap-1 text-neutral-500 text-xs",
  officeClassName = "min-w-0",
  floorClassName = "min-w-0 max-w-64 truncate"
}: OfficeFloorInfoProps) {
  const rawOffice = officeName ?? "";
  const rawFloor = floorName ?? "";

  if (!rawOffice && !rawFloor) {
    return null;
  }

  // Choose a maxLength appropriate for this line; tweak as needed
  const { officeName: truncatedOfficeName, floorName: truncatedFloorName } =
    truncateOfficeAndFloor(rawOffice, rawFloor, undefined, 55);

  const showOffice = !!truncatedOfficeName;
  const showFloor = !!truncatedFloorName;
  const showSeparator = showOffice && showFloor;

  return (
    <div className={className}>
      {showOffice && (
        <span className={officeClassName} title={rawOffice}>
          {truncatedOfficeName}
        </span>
      )}

      {showSeparator && <span className="flex-shrink-0">·</span>}

      {showFloor && (
        <span className={floorClassName} title={rawFloor}>
          {truncatedFloorName}
        </span>
      )}
    </div>
  );
}
